import React from 'react';
import { ButtonOutLine } from '../utils/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const CookiesConsent = ({ handleReject, handleManage, handleSelection }) => {
  const navigate = useNavigate()
  const { t } = useTranslation();
  return (
    <div className="flex justify-between items-center gap-5 max_md:flex-col max_md:items-start">
      <div className="max-w-[70%] max_md:max-w-full">
        <p className="smallText16 mt-4 text-LightPrimary">
          {t('CookieText')}{' '}
          <span
            className="cursor-pointer smallText16 text-ButtonPrimary underline"
            onClick={() => navigate('/legal/cookie-policy')}
          >
            {t('CookiePolicyH')}
          </span>
        </p>
      </div>

      <div className="flex gap-3 items-center max_md:justify-between max_md:w-full max_sm:flex-col-reverse max_sm:gap-5">
        <p
          className="cursor-pointer underline smallText16 text-ButtonPrimary w-max h-max"
          onClick={handleManage}
        >
          {t('ManageCookies')}
        </p>
        <div className="flex gap-3 items-center max_sm:gap-[6px]">
          <ButtonOutLine
            width="98px"
            fontSize="16px"
            title={t('Reject')}
            isFilled={false}
            onClick={() => handleSelection('reject')}
          />
          <ButtonOutLine
            title={t('AcceptAll')}
            rounded="8px"
            fontSize="16px"
            isFilled={true}
            background="#00A0FC"
            width="116px"
            onClick={() => handleSelection('accept')}
          />
        </div>
      </div>
    </div>
  );
};

export default CookiesConsent;
